import React from "react";
import {
  getAllUsersDetails,
  getAllUsersMeta,
  getPendingVerifiedBoatTypes,
} from "../utils";
import { useState, useEffect } from "react";
import DataTable from "../UsersDataTable";

export default function PendingUsers() {
  const [allUsers, setAllUsers] = useState([]);
  const [usersMeta, setUsersMeta] = useState({});

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const [allUsersData, allUsersMeta] = await Promise.all([
          getAllUsersDetails(),
          getAllUsersMeta(),
        ]);
        const usersMetaMap = (allUsersMeta || []).reduce((acc, meta) => {
          const userId = meta.uid || meta.userId;
          if (userId) {
            acc[userId] = meta;
          }
          return acc;
        }, {});
        setAllUsers(allUsersData);
        setUsersMeta(usersMetaMap);
      } catch (error) {
        console.error("Error fetching pending renters:", error);
      }
    };

    fetchUsers();
  }, []);

  const columns = [
    {
      Header: "BBR ID",
      accessor: "bbrId",
    },
    {
      Header: "Full Name",
      accessor: "name",
    },
    {
      Header: "Pending Verification",
      accessor: "pendingVerification",
    },
    {
      Header: "Phone",
      accessor: "phone",
    },
    {
      Header: "Email",
      accessor: "email",
    },
  ];

  const linkUsersAndUsersMeta = () => {
    return allUsers
      .map((user) => {
        if (user.role === "Renter" && !user.isDeleted) {
          const userId = user.userId || user.id;
          const pendingTypes = getPendingVerifiedBoatTypes(
            user,
            usersMeta[userId]
          );

          if (pendingTypes.length > 0) {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`,
              pendingVerification: pendingTypes.join(", "),
            };
          }
        }

        return null;
      })
      .filter(Boolean);
  };

  const data = linkUsersAndUsersMeta();

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="page-description">
            <h1>Pending Users</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card calendar-container">
            <div className="card-body">
              <DataTable columns={columns} data={data} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
